import { Col, Form, Input, InputNumber, Row, Select, Switch, TimePicker } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import dayjs from 'dayjs';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';

export default function MenuSaleTimeEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 折扣类型数据 */
    const [discountTypeData, setDiscountTypeData] = useState<any>();

    /** 选择折扣类型数据 */
    const [selectDiscountTypeData, setSelectDiscountTypeData] = useState<any>();

    /**折扣数据 */
    const [disCountData, setDisCountData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = "";

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    // console.log(res.data);
                    // form.setFieldsValue({ menuSalePeriodId: res.data.menuSalePeriodId });\
                    setSelectDiscountTypeData(res.data.discountType);
                    if (res.data.discountType === 'price') {
                        form.setFieldsValue({ price: res.data.discount });
                    }
                }
            })
        }
        const fetchData = async () => {
            form.setFieldsValue({ menuSalePeriodId: data.sendPageData.menuSalePeriodId });
            form.setFieldsValue({ weekName: data.sendPageData.weekName });
            form.setFieldsValue({ targetKey: data.sendPageData.targetKey });
            form.setFieldsValue({ targetId: data.sendPageData.targetId });
            form.setFieldsValue({ dateType: data.sendPageData.dateType });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

            fetchApi.GET(wmService, {
                apiId: 'generalData',
                apiVariable: 'discountType',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    // setDiscountTypeData(res.data);
                    newDiscountTypeData(res.data, setDiscountTypeData, data.sendPageData.targetKey);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "disCount",
                apiExtend: 'showList',
            }).then(res => {
                if (res.success) {
                    let newData: Array<any> = [];
                    for (var i = 0; i < res.data.length; i++) {
                        newData.push({
                            value: res.data[i].disCount,
                            label: res.data[i].disCountName,
                        })
                    }
                    setDisCountData(newData);
                }
            });
        }
        fetchData();
    }, [])

    const newDiscountTypeData = async (rows: any, setData: any, targetKey: any) => {
        let newSelectData: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            newSelectData.push({
                value: rows[j].id,
                label: rows[j].name,
                disabled: targetKey !== 'menuSpec' && rows[j].id === 'price' ? true : false
                // disabled: targetKey === 'shopType'  && rows[j].id === 'price' ? true : false
            })
        }
        setData(newSelectData);
    }

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const getDiscountTypeData = (discountTypeId: string) => {
        setSelectDiscountTypeData(discountTypeId);
        form.setFieldsValue({ discount: '' });
    }

    const changeDate = (e: any, key: any) => {
        if (key === 'startTime' && form.getFieldsValue()['endTime'] !== undefined) {
            if (dayjs(form.getFieldsValue()['endTime']).format("HH:mm") < dayjs(e).format("HH:mm")) {
                antMessage('error', '时间设置有误', '结束时间小于开始时间,请重新选择.');
                form.resetFields(['startTime']);
            }
        }

        if (key === 'endTime') {
            if (dayjs(form.getFieldsValue()['startTime']).format("HH:mm") > dayjs(e).format("HH:mm")) {
                antMessage('error', '时间设置有误', '开始时间大于结束时间,请重新选择.');
                form.resetFields(['endTime']);
            }
        }
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuSaleTime',
        dateColumnName: ['startTime', 'endTime'],
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '销售 / 折扣时段'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="branchStoreId"
                                name="branchStoreId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        {/* <Col span={24}>
                            <Form.Item
                                label="menuSaleDateId"
                                name="menuSaleDateId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col> */}

                        <Col span={0}>
                            <Form.Item
                                label="targetKey"
                                name="targetKey">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="targetId"
                                name="targetId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="dateType"
                                name="dateType">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="menuSalePeriodId"
                                name="menuSalePeriodId"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="周期"
                                name="weekName"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="开始时间"
                                name="startTime"
                                rules={[{
                                    required: true,
                                    message: '请选择开始时间',
                                }]}>
                                <TimePicker
                                    onChange={(e) => changeDate(e, 'startTime')}
                                    format="HH:mm" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="结束时间"
                                name="endTime"
                                rules={[{
                                    required: true,
                                    message: '请选择结束时间',
                                }]}>
                                <TimePicker
                                    onChange={(e) => changeDate(e, 'endTime')}
                                    format="HH:mm" />
                            </Form.Item>
                        </Col>

                        <Col span={data.sendPageData.dateType === 'discount' ? 12 : 0}>
                            <Form.Item
                                label="折扣类型"
                                name="discountType"
                                rules={[{ required: data.sendPageData.dateType === 'discount' ? true : false, message: '请选择折扣类型' }]}
                            >
                                <Select
                                    placeholder="折扣类型"
                                    optionFilterProp="children"
                                    onSelect={getDiscountTypeData}
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                    options={discountTypeData}
                                >
                                </Select>
                                {/* <Select
                                    placeholder="折扣类型"
                                    optionFilterProp="children"
                                    onSelect={getDiscountTypeData}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {getList.generalEx(discountTypeData, {
                                        includeNull: false
                                    })}
                                </Select> */}
                            </Form.Item>
                        </Col>

                        <Col span={(selectDiscountTypeData === 'price' && data.sendPageData.dateType === 'discount') ? 12 : 0}>
                            <Form.Item
                                label={"折后价"}
                                name="price"
                                rules={[{ required: (selectDiscountTypeData === 'price' && data.sendPageData.dateType === 'discount') ? true : false, message: '请输入折后价!' }]}>
                                <InputNumber min={0} max={data.sendPageData.price} addonBefore={'¥'} />
                            </Form.Item>
                        </Col>

                        <Col span={(selectDiscountTypeData === 'discount' && data.sendPageData.dateType === 'discount') ? 12 : 0}>
                            <Form.Item
                                label={"折扣"}
                                name="discount"
                                rules={[{ required: (selectDiscountTypeData === 'discount' && data.sendPageData.dateType === 'discount') ? true : false, message: '请输入折扣!' }]}>
                                <Select
                                    placeholder="折扣"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    options={disCountData}
                                >
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={data.sendPageData.dateType === 'discount' ? 24 : 0}>
                            <Form.Item
                                label="固定折扣"
                                name="isFixDiscount"
                                valuePropName="checked"
                                initialValue={false}>
                                <Switch
                                    checkedChildren="固定"
                                    unCheckedChildren="不固定" />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}